import { Resource } from './resource';
import gql from 'graphql-tag';

export class AuthenticationResource extends Resource {
  public static async login(email: string, password: string) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($email: String!, $password: String!) {
            login(email: $email, password: $password) {
              token
            }
          }
        `,
        variables: { email, password }
      },
      'login'
    );
  }
}
